import React, { useEffect, useState } from "react";
import AppTextField from "../../components/text-field";
import Footer from "../../components/footer";
import Header from "../../components/header";
import Lock from "../../assets/checkout/lock.svg";
import StarGold from "../../assets/checkout/star-gold-orange.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import AppButton from "../../components/button";
import LOGO from "../../assets/logo/insightfulTraitsLogo.png";
import ComodoSeal from "../../assets/logo/comodo-secure-seal.png";
import ALL_CARDS from "../../assets/checkout/card-group-icon.png";
import PAYPAL_LOGO from "../../assets/checkout/paypal-icon.svg";
import CryptoJS from "crypto-js";
import "./gpay.css";
import axios from "axios";
import { readCookie } from "../../utils/helpers";
import Arrow from "../..//assets/sell/sell-button-arrow.svg";
import { useTranslation } from "react-i18next";
import {
  getTokenExID,
  getTokenExSecretKey,
  getTokenExScheme,
  getPaypalHostUrl,
  getPaypalClientSecret,
  getPaypalClientId,
  getChargBeeSiteName,
  getChargBeeUserName,
  paymentMode,
} from "../../utils/payment-config";
import { loadScript, removeScript } from "../../utils/helpers";
import {
  allowOnlyNumbers,
  validateCardHolderName,
  validateExpMonth,
  validateExpYear,
  validateState,
  formatPostalCode,
  formatCityState,
  validateCity,
  validateZip,
  validatePostalCode,
  formatLabel,
} from "../../utils/validation";
import { getPortalCD } from "../../utils/helpers";
import { COUNTRY_CODE, getTokenExIframeJs } from "../../utils/general-config";
import DropDownSelector from "../../components/drop-down-selector";
import {
  formatDateString,
  formatToTwoDecimalPlaces,
  getBrowserAndDeviceInfo,
  getCookie,
  getMonthYearOptions,
} from "../../utils/utility-functions";
import Loader from "../../components/loader";
import "./checkout.css";
import useMediaQuery from "../../utils/media-query";
import { trackEvents } from "../../utils/tracking-events";
import { toast } from "react-toastify";
import PathHelper from "../../utils/path-helper";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";

const CheckoutB = ({
  funnelStep,
  createWalletPaymentIntentConnect,
  doCheckOutConnect,
  GetUserByIdConnect,
  IsGuestOrPremiumUserConnect,
  createCBPaymentIntentConnect,
  userMetaConnect,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [showApplePay, setShowApplePay] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const pt = queryParams.get("pt");
  const pn = queryParams.get("pn");
  const pg = queryParams.get("pg");
  const personalityNameEnglishCode = queryParams.get("pnes");
  const currentassessmentAttemptId = queryParams.get("assessmentAttemptId");
  const {
    selectedPlan,
    email,
    assessmentId,
    userGUID,
    gender,
    assessmentAttemptId,
    countryCD,
    currencyCD,
    ipAddress,
  } = funnelStep || {};
  // const token = localStorage.getItem("jwtToken");
  const token = getCookie("jwtToken");
  const currentDate = new Date();
  const [cbInstance, setCbInstance] = useState(null);
  const { t } = useTranslation();

  //const country = COUNTRY_CODE.USA;
  const country = getCookie("country");
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const dashboardPath = PathHelper(APP_NAVIGATION.DASHBOARD, currentLocale);
  const confirmationPath = PathHelper(
    APP_NAVIGATION.CONFIRMATION,
    currentLocale
  );
  const loginPath = PathHelper(APP_NAVIGATION.SINI, currentLocale);

  const isVisibleCityState = country !== COUNTRY_CODE.INDIA;
  const isVisibleZip = country === COUNTRY_CODE.USA; // ZIP Code is only for USA
  const isVisiblePostCode =
    country === COUNTRY_CODE.UK || country === COUNTRY_CODE.CANADA; // UK and Canada have Postal Codes
  const stateName =
    country === COUNTRY_CODE.CANADA
      ? t("checkout.province")
      : country === COUNTRY_CODE.USA
      ? t("checkout.state")
      : t("checkout.county");
  const cityName =
    country === COUNTRY_CODE.USA || country === COUNTRY_CODE.CANADA
      ? t("checkout.city")
      : t("checkout.town_city");
  const postCodeName =
    country === COUNTRY_CODE.UK
      ? t("checkout.post_code")
      : t("checkout.postal_code");

  // For monthly plan: 14 days from now
  const after14Days = new Date(
    currentDate.getTime() + 14 * 24 * 60 * 60 * 1000
  );

  // For annual plan: 1 year from now
  const after1Year = new Date(currentDate);
  after1Year.setFullYear(currentDate.getFullYear() + 1);

  const annualPlanTerms = `<b>${t("checkout.cancelMessage")}</b>${t(
    "checkout.paymentMessage"
  )} ${selectedPlan?.currencySymbol}${formatToTwoDecimalPlaces(
    selectedPlan?.recurringPrice
  )} every year starting on`;
  const monthlyPlanTerms = `${t("checkout.accessDuration")}  <b>${t(
    "checkout.cancelMessage"
  )}</b> ${t("checkout.paymentMessage")} ${
    selectedPlan?.currencySymbol
  }${formatToTwoDecimalPlaces(selectedPlan?.recurringPrice)} ${t(
    "checkout.every_4_weeks"
  )}`;

  const isAnnualPlan = selectedPlan?.title === "Annual Plan";

  const terms = isAnnualPlan ? annualPlanTerms : monthlyPlanTerms;
  const termsDate = isAnnualPlan
    ? formatDateString(after1Year, t)
    : formatDateString(after14Days, t);

  const [clientSecret, setClientSecret] = useState("");
  useEffect(() => {
    if (userGUID) {
      IsGuestOrPremiumUserConnect(userGUID).then((res) => {
        if (res && res?.isPremiumOrGuestUser) {
          navigate(dashboardPath.next);
        }
      });
    }
  }, [userGUID]);

  const createPaymentData = ({
    customFieldsData,
    customerSource = "",
    paypalToken = "",
    applePayToken = "",
    paymentToken = "",
    tokenizedData = {},
    expMonth = "",
    expYear = "",
  }) => {
    return {
      assessmentId: assessmentId,
      firstName: email,
      lastName: "",
      email: email,
      skuGuid: queryParams.get("sku"),
      userGuid: userGUID,
      portalSource: getPortalCD(),
      customFields: customFieldsData,
      customerSource,
      paypalToken,
      applePayToken,
      ipAddress: ipAddress,
      currency: currencyCD,
      assessmentAttemptId: currentassessmentAttemptId || "",
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
      maxSubUserCount: selectedPlan?.maxSubUserCount,
      paymentToken,
      //userAddress: !!userAddress ? userAddress : null,
      userAddress: Object.values(userAddress).some((value) => value !== "")
        ? userAddress
        : null,
      ccDetails: tokenizedData.token
        ? {
            cardType: tokenizedData.cardType,
            token: tokenizedData.token,
            ccExpiryMonth: expMonth,
            ccExpiryYear: expYear,
            cvv: "0",
          }
        : null, // Handle cases where there's no tokenized data
    };
  };

  const MONTH_OPTIONS = getMonthYearOptions(t).month;
  const YEAR_OPTIONS = getMonthYearOptions(t).year;

  const { browser, device } = getBrowserAndDeviceInfo();

  useEffect(() => {
    trackEvents("checkoutView", {
      userGuid: userGUID,
      email: email,
      eventLabel: "Page View",
      assessmentAttemptId: assessmentAttemptId,
      countryCD: countryCD,
      currencyCD: currencyCD,
      portalCD: getPortalCD(),
      gender: gender,
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
    });
    // Initialize Chargebee instance
    //const initializeChargebee = () =>
    {
      if (window.Chargebee) {
        const cbInstance = window.Chargebee.init({
          site: getChargBeeSiteName(), // Replace with your site name
          publishableKey: getChargBeeUserName(), // Replace with your publishable key
        });
        setCbInstance(cbInstance);
      } else {
        console.error("Chargebee library not loaded.");
      }
    }

    // Wait for the window to be fully loaded before initializing Chargebee
    // window.addEventListener("load", initializeChargebee);
  }, []);

  const useDeviceAndBrowser = () => {
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Check if the device is iOS (iPhone, iPad, iPod)
      const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

      // Check if the browser is Safari (excluding Chrome and other browsers that include "Safari")
      const isSafari = /Safari/i.test(userAgent) && !/Chrome/i.test(userAgent);

      // Set the state to true only if both conditions are true
      setIsValid(isIOS || isSafari);
    }, []); // Empty dependency array ensures this runs once when the component mounts

    return isValid;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isLoading]);

  const isIOSOrSafari = useDeviceAndBrowser();
  useEffect(() => {
    const timer = setTimeout(() => {
      if (queryParams.has("pplrtrn") && queryParams.has("token")) {
        //do nothing
      } else {
        setIsLoading(false);
      }
    }, 5000);

    // Cleanup the timer when the component unmounts

    const loadApplePay = async () => {
      setIsLoading(true);
      if (!cbInstance) return; // Wait for cbInstance to be defined

      try {
        setShowApplePay(true);
        const applePayHandler = await cbInstance.load("apple-pay");

        const params = {
          amount:
            selectedPlan?.scheduleTypeCD === "YEAR"
              ? selectedPlan?.recurringPrice * 100
              : selectedPlan?.unitPrice * 100,
          currencyCode: "usd",
          paymentMethodType: paymentMode.APPLEPAY,
        };
        try {
          const response = await createWalletPaymentIntentConnect(params);
          if (response) {
            const paymentIntent = {
              id: response.id,
              amount: response.amount,
              currency_code: response.currency_code,
              gateway: response.gateway,
              gateway_account_id: response.gateway_account_id,
              expires_at: response.expires_at,
              payment_method_type: response.payment_method_type,
              created_at: response.created_at,
              modified_at: response.modified_at,
              object: response.object,
              status: response.status,
            };

            // Set the payment intent
            applePayHandler.setPaymentIntent(paymentIntent);

            // Mount the payment button
            await applePayHandler.mountPaymentButton("#apple-pay-button");
            // Handle payment
            applePayHandler.handlePayment({
              success: function (result) {
                let customFieldsData = {
                  ipcountry: countryCD,
                  protalsrc: getPortalCD(),
                  userguid: userGUID,
                };
                let subscriptionsource = "default";
                let data = createPaymentData({
                  customFieldsData,
                  customerSource: subscriptionsource,
                  paypalToken: "",
                  applePayToken: "",
                  paymentToken: result.paymentIntent.id,
                  tokenizedData: {}, // Since ccDetails is null in the original data
                  expMonth: "",
                  expYear: "",
                });
                data.paymentMethodType = paymentMode.APPLEPAY;

                // let data = {
                //   assessmentId: assessmentId,
                //   firstName: email,
                //   lastName: "",
                //   email: email,
                //   skuGuid: queryParams.get("sku"),
                //   userGuid: userGUID,
                //   portalSource: getPortalCD(),
                //   customFields: customFieldsData,
                //   customerSource: subscriptionsource,
                //   visitId: readCookie("visitGuid"),
                //   visitorId: readCookie("visitorGuid"),
                //   paypalToken: "",
                //   paymentToken: result.paymentIntent.id,
                //   ipAddress: ipAddress,
                //   currency: currencyCD,
                //   ccDetails: null,
                //   assessmentAttemptId: currentassessmentAttemptId || "",
                //   paymentMethodType: paymentMode.APPLEPAY,
                //   maxSubUserCount: selectedPlan?.maxSubUserCount,
                //   userAddress: !!userAddress ? userAddress : null,
                // };

                setIsLoading(true);
                let userMetaData = {
                  visitId: readCookie("visitGuid"),
                  visitorId: readCookie("visitorGuid"),
                  email: email,
                  device: device,
                  browser: browser,
                  paymentRequest: JSON.stringify(data),
                  isPaymentButtonClicked: true,
                };

                userMetaConnect(userMetaData)
                  .then((res) => {})
                  .catch((err) => {
                    console.log({ err });
                  });
                doCheckOutConnect(data)
                  .then((response) => {
                    if (!!response) {
                      if (response === parseInt(0)) {
                        window.flag = true;
                        toast.error(
                          t("checkout.payment_declined"),
                          { autoClose: 5000 } // 5000 milliseconds = 5 seconds
                        );
                      } else {
                        // console.log("doCheckOutConnect RESPONSE :::", response);
                        trackEvents("paymentSuccess", {
                          userGuid: userGUID,
                          email: email,
                          eventLabel: "Page View",
                          assessmentAttemptId: assessmentAttemptId,
                          countryCD: countryCD,
                          currencyCD: currencyCD,
                          portalCD: getPortalCD(),
                          gender: gender,
                          visitId: readCookie("visitGuid"),
                          visitorId: readCookie("visitorGuid"),
                        });

                        const encodedPg = encodeURIComponent(pg);
                        const confirmationUrl = `${confirmationPath.next}?pt=${pt}&oid=${response}&pn=${pn}&pnes=${personalityNameEnglishCode}&pg=${encodedPg}`;
                        navigate(confirmationUrl);
                      }
                    } else {
                      window.flag = true;
                      toast.error(
                        t("checkout.payment_declined"),
                        { autoClose: 5000 } // 5000 milliseconds = 5 seconds
                      );
                    }
                  })
                  .catch((error) => {
                    setIsLoading(false);
                    window.flag = true;
                    // console.error("doCheckOutConnect failed", error);
                    trackEvents("paymentFailure", {
                      userGuid: userGUID,
                      email: email,
                      eventLabel: "Page View",
                      assessmentAttemptId: assessmentAttemptId,
                      countryCD: countryCD,
                      currencyCD: currencyCD,
                      portalCD: getPortalCD(),
                      gender: gender,
                      visitId: readCookie("visitGuid"),
                      visitorId: readCookie("visitorGuid"),
                    });
                  })
                  .finally(() => {
                    window.flag = true;
                    setIsLoading(false); // Stop loader
                  });
              },
              error: function (error) {
                window.flag = true;
                console.log("error", error);
              },
            });
          }
        } catch (error) {
          console.error("Error creating payment intent:", error);
        }
      } catch (error) {
        console.error("Error loading Apple Pay:", error);
      }
      return () => clearTimeout(timer);
    };

    const loadGPay = async () => {
      setIsLoading(true);
      if (!cbInstance) return; // Wait for cbInstance to be defined

      try {
        const gPayHandler = await cbInstance.load("google-pay");
        const params = {
          amount:
            selectedPlan?.scheduleTypeCD === "YEAR"
              ? selectedPlan?.recurringPrice * 100
              : selectedPlan?.unitPrice * 100,
          currencyCode: "usd",
          paymentMethodType: paymentMode.GOOGLEPAY,
        };
        try {
          const intent = await createWalletPaymentIntentConnect(params);
          if (intent) {
            const paymentIntent = {
              id: intent.id,
              amount: intent.amount,
              currency_code: intent.currency_code,
              gateway: intent.gateway,
              gateway_account_id: intent.gateway_account_id,
              expires_at: intent.expires_at,
              payment_method_type: intent.payment_method_type,
              created_at: intent.created_at,
              modified_at: intent.modified_at,
              object: intent.object,
              status: intent.status,
            };
            // Set the payment intent
            gPayHandler.setPaymentIntent(paymentIntent);
            await gPayHandler.mountPaymentButton("#gpay-button");
            const gPayButton = document.querySelector("#gpay-button");
            gPayButton.addEventListener("click", function () {
              setIsLoading(true);
              gPayHandler.handlePayment({
                success: function (result) {
                  setIsLoading(true);
                  let customFieldsData = {
                    ipcountry: countryCD,
                    protalsrc: getPortalCD(),
                    userguid: userGUID,
                  };
                  let subscriptionsource = "default";
                  let data = createPaymentData({
                    customFieldsData,
                    customerSource: subscriptionsource,
                    paypalToken: "",
                    applePayToken: "",
                    paymentToken: result.paymentIntent.id,
                    tokenizedData: {}, // Ensuring ccDetails remains null
                    expMonth: "",
                    expYear: "",
                  });
                  // Add paymentMethodType separately
                  data.paymentMethodType = paymentMode.GOOGLEPAY;
                  // let data = {
                  //   firstName: email,
                  //   lastName: "",
                  //   email: email,
                  //   skuGuid: queryParams.get("sku"),
                  //   userGuid: userGUID,
                  //   portalSource: getPortalCD(),
                  //   customFields: customFieldsData,
                  //   customerSource: subscriptionsource,
                  //   visitId: readCookie("visitGuid"),
                  //   visitorId: readCookie("visitorGuid"),
                  //   paypalToken: "",
                  //   paymentToken: result.paymentIntent.id,
                  //   ipAddress: ipAddress,
                  //   currency: currencyCD,
                  //   ccDetails: null,
                  //   assessmentId: assessmentId,
                  //   assessmentAttemptId: currentassessmentAttemptId || "",
                  //   paymentMethodType: paymentMode.GOOGLEPAY,
                  //   maxSubUserCount: selectedPlan?.maxSubUserCount,
                  //   userAddress: !!userAddress ? userAddress : null,
                  // };

                  let userMetaData = {
                    visitId: readCookie("visitGuid"),
                    visitorId: readCookie("visitorGuid"),
                    email: email,
                    device: device,
                    browser: browser,
                    paymentRequest: JSON.stringify(data),
                    isPaymentButtonClicked: true,
                  };

                  userMetaConnect(userMetaData)
                    .then((res) => {})
                    .catch((err) => {
                      console.log({ err });
                    });
                  doCheckOutConnect(data)
                    .then((response) => {
                      if (!!response) {
                        if (response === parseInt(0)) {
                          window.flag = true;
                          toast.error(
                            t("checkout.payment_declined"),
                            { autoClose: 5000 } // 5000 milliseconds = 5 seconds
                          );
                        } else {
                          // console.log("doCheckOutConnect RESPONSE :::", response);
                          trackEvents("paymentSuccess", {
                            userGuid: userGUID,
                            email: email,
                            eventLabel: "Page View",
                            assessmentAttemptId: assessmentAttemptId,
                            countryCD: countryCD,
                            currencyCD: currencyCD,
                            portalCD: getPortalCD(),
                            gender: gender,
                            visitId: readCookie("visitGuid"),
                            visitorId: readCookie("visitorGuid"),
                          });

                          const encodedPg = encodeURIComponent(pg);
                          const confirmationUrl = `${confirmationPath.next}?pt=${pt}&oid=${response}&pn=${pn}&pnes=${personalityNameEnglishCode}&pg=${encodedPg}`;
                          navigate(confirmationUrl);
                        }
                      } else {
                        window.flag = true;
                        setIsLoading(false);
                        toast.error(
                          t("checkout.payment_declined"),
                          { autoClose: 5000 } // 5000 milliseconds = 5 seconds
                        );
                      }
                    })
                    .catch((error) => {
                      setIsLoading(false);
                      window.flag = true;
                      // console.error("doCheckOutConnect failed", error);
                      trackEvents("paymentFailure", {
                        userGuid: userGUID,
                        email: email,
                        eventLabel: "Page View",
                        assessmentAttemptId: assessmentAttemptId,
                        countryCD: countryCD,
                        currencyCD: currencyCD,
                        portalCD: getPortalCD(),
                        gender: gender,
                        visitId: readCookie("visitGuid"),
                        visitorId: readCookie("visitorGuid"),
                      });
                    })
                    .finally(() => {
                      window.flag = true;
                      setIsLoading(false); // Stop loader
                    });
                },
                error: function (error) {
                  window.flag = true;
                  setIsLoading(false);
                  console.log("gpay error", error);
                  toast.error(t("checkout.payment_declined"), {
                    autoClose: 5000,
                  });
                },
              });
            });
          }
        } catch (error) {
          setIsLoading(false);

          console.error("gpay error:", error);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("gpay error:", error);
      }
    };

    if (isIOSOrSafari) {
      loadApplePay();
    }
    loadGPay();
  }, [cbInstance]);

  const [hasClicked, setHasClicked] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const [formData, setFormData] = useState({
    cardholderName: "",
    expMonth: "",
    expYear: "",
    cardNumber: "",
    cvv: "",
    city: "",
    state: "",
    postCode: "",
    zip: "",
  });

  const [error, setError] = useState({
    cardholderNameError: "",
    expMonthError: "",
    expYearError: "",
    cvvError: "",
    cardNumberError: "",
    cityError: "",
    stateError: "",
    postalCodeError: "",
    zip: "",
  });

  const isError =
    error?.cardholderNameError ||
    error?.expMonthError ||
    error?.expYearError ||
    error?.cvvError ||
    error.cardNumberError ||
    error?.postalCodeError ||
    error?.stateError ||
    error?.cityError ||
    error?.zipError;

  useEffect(() => {
    if (
      error?.cardholderNameError ||
      error?.expMonthError ||
      error?.expYearError ||
      error?.cvvError ||
      error.cardNumberError ||
      error?.postalCodeError ||
      error?.stateError ||
      error?.cityError ||
      error?.zipError ||
      !formData.cardholderName ||
      !formData.expMonth ||
      !formData.expYear ||
      (isVisibleCityState && !formData.city) ||
      (isVisibleCityState && !formData.state) ||
      (isVisibleZip && !formData.zip) ||
      (isVisiblePostCode && !formData.postCode)
    ) {
      setButtonDisable(true);
    } else {
      setButtonDisable(false);
    }
  }, [isError, error]);

  useEffect(() => {
    if (!token) {
      navigate(loginPath.next);
    }
  }, [token]);

  const nameParts = formData.cardholderName.split(" ");
  const FIRST_NAME = nameParts[0];
  const lastNamePart1 = nameParts[1] || ""; // Get the second part, or an empty string if undefined
  const lastNamePart2 = nameParts[2] || "";
  const LAST_NAME = lastNamePart1 + lastNamePart2;
  const EXP_MONTH = formData.expMonth;
  const EXP_YEAR = formData.expYear;
  const isLargeScreen = useMediaQuery("(min-width: 640px)");

  // const handleInputChange = (event) => {
  //   const { name, value } = event.target;
  //   let error = "";
  //   const isExpMonthError = validateExpMonth(name.expMonth, name.expYear);
  //   const isExpYearError = validateExpYear(name.expYear, name.expMonth);
  //   if (name === "cardholderName") {
  //     error = validateCardHolderName(value);
  //   } else if (name === "expMonth") {
  //     error = validateExpMonth(value, formData.expYear);
  //   } else if (name === "expYear") {
  //     error = validateExpYear(value, formData.expMonth);
  //   }

  //   setError((prevError) => ({ ...prevError, [`${name}Error`]: error }));
  //   setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  // };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    let error = "";

    // First, update the formData with the new value
    const updatedFormData = { ...formData, [name]: value };

    // Validate based on the input field's name
    if (name === "cardholderName") {
      error = validateCardHolderName(value, t);
    } else if (name === "cardNumber") {
      //error = ""; //validateCardNumber(value);
    } else if (name === "cvv") {
      //error = ""; //validateCVV(value, updatedFormData.cvv);
    } else if (name === "expMonth") {
      error = validateExpMonth(value, updatedFormData.expYear, t);
    } else if (name === "expYear") {
      error = validateExpYear(value, updatedFormData.expMonth, t);
    } else if (name === "state" && isVisibleCityState) {
      error = validateState(value, stateName, t);
    } else if (name === "city" && isVisibleCityState) {
      error = validateCity(value, cityName, t);
    } else if (name === "zip" && isVisibleZip) {
      error = validateZip(value, t);
    } else if (name === "postCode" && isVisiblePostCode) {
      error = validatePostalCode(value, postCodeName, t);
    }

    // Set the individual error
    setError((prevError) => ({ ...prevError, [`${name}Error`]: error }));

    // Validate the combination of month and year after updating formData
    if (name === "expMonth" || name === "expYear") {
      const expMonthError = validateExpMonth(
        updatedFormData.expMonth,
        updatedFormData.expYear,
        t
      );
      const expYearError = validateExpYear(
        updatedFormData.expYear,
        updatedFormData.expMonth,
        t
      );

      // Set the combination errors
      setError((prevError) => ({
        ...prevError,
        expMonthError,
        expYearError,
      }));
    }

    // Finally, update the formData state
    setFormData(updatedFormData);
  };

  useEffect(() => {
    //if (!!readCookie("jwtToken"))
    {
      let isPayPalPaymentCancel = queryParams.get("cancel") || "";
      var currentUrl = new URL(window.location.href);
      if (!!isPayPalPaymentCancel && isPayPalPaymentCancel === "true") {
        if (window.location.href.indexOf("cancel") > -1) {
          currentUrl.searchParams.delete("token");
          currentUrl.searchParams.delete("ba_token");
          currentUrl.searchParams.delete("cancel");
          window.history.pushState({}, "", currentUrl);
        }
        //TODO: show try again error
      } else {
        if (
          queryParams.has("pplrtrn") &&
          queryParams.has("token") &&
          !queryParams.has("ispaypalsuccess")
        ) {
          var currentUrl = new URL(window.location.href);
          if (window.location.href.indexOf("ispaypalsuccess=true") <= 0) {
            currentUrl.searchParams.append("ispaypalsuccess", "true");
            window.history.pushState({}, "", currentUrl);
          }
          setIsLoading(true);
          excecutePaypalProcess(queryParams.get("token"));
        }
      }
    }
    loadScript(getTokenExIframeJs());
    // loadScript("/app/assessment/tokenEXscript.js");
    return () => {
      // removeScript("/app/assessment/tokenEXscript.js");
      removeScript(getTokenExIframeJs());
    };
  }, []);

  const createHmac = () => {
    var concatinatedString =
      getTokenExID() +
      "|" +
      window.location.origin +
      "|" +
      getUTCTimeStamp() +
      "|" +
      getTokenExScheme();
    var hash = CryptoJS.HmacSHA256(concatinatedString, getTokenExSecretKey());
    var hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
    return hashInBase64;
  };
  const getUTCTimeStamp = () => {
    var date = new Date();
    return (
      date.getFullYear() +
      ("0" + (date.getUTCMonth() + 1)).slice(-2) +
      ("0" + date.getUTCDate()).slice(-2) +
      ("0" + date.getUTCHours()).slice(-2) +
      ("0" + date.getUTCMinutes()).slice(-2) +
      ("0" + date.getUTCSeconds()).slice(-2)
    );
  };

  window.validateIframe = (data) => {
    if ((data && !data.isValid) || (data && data.cardType === "unknown")) {
      setError((prevError) => ({
        ...prevError,
        cardNumberError:
          !data.isValid || data.cardType === "unknown"
            ? t("checkout.invalid_card_number")
            : "",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        cardNumberError: "",
      }));
    }
    if (data && !data.isCvvValid) {
      setError((prevError) => ({
        ...prevError,
        cvvError: !data.isCvvValid ? t("checkout.invalid_cvv_text") : "",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        cvvError: "",
      }));
    }
  };

  const onPaymentClickHandler = (e) => {
    e.preventDefault(); // Prevent default form submission

    setHasClicked(true);

    const {
      cardholderName,
      cardNumber,
      cvv,
      expMonth,
      expYear,
      city,
      state,
      zip,
      postCode,
    } = formData;
    const isCardholderNameError = validateCardHolderName(
      cardholderName.trim(),
      t
    );
    const isExpMonthError = validateExpMonth(expMonth, expYear, t);
    const isExpYearError = validateExpYear(expYear, expMonth, t);
    const isStateError = validateState(state, stateName, t);
    const isCityError = validateCity(city, cityName, t);
    const isZipError = validateZip(zip, t);
    const isPostCodeError = validatePostalCode(postCode, postCodeName, t);

    // const isCvvError = window.validateIframe(cvv);
    // const isCardNumberError = window.validateIframe(cardNumber);

    // let hasError = false;

    if (isCardholderNameError.length > 0) {
      setIsLoading(false);
      setError((prevError) => ({
        ...prevError,
        cardholderNameError: isCardholderNameError,
      }));
      // hasError = true;
    } else {
      setError((prevError) => ({ ...prevError, cardholderNameError: "" }));
    }

    if (isExpMonthError.length > 0) {
      setIsLoading(false);
      setError((prevError) => ({
        ...prevError,
        expMonthError: isExpMonthError,
      }));
      // hasError = true;
    } else {
      setError((prevError) => ({ ...prevError, expMonthError: "" }));
    }

    if (isExpYearError.length > 0) {
      setIsLoading(false);
      setError((prevError) => ({ ...prevError, expYearError: isExpYearError }));
      // hasError = true;
    } else {
      setError((prevError) => ({ ...prevError, expYearError: "" }));
    }

    if (isCityError.length > 0) {
      setIsLoading(false);
      setError((prevError) => ({ ...prevError, cityError: isCityError }));
    } else {
      setError((prevError) => ({ ...prevError, cityError: "" }));
    }

    if (isStateError.length > 0) {
      setIsLoading(false);
      setError((prevError) => ({ ...prevError, stateError: isStateError }));
    } else {
      setError((prevError) => ({ ...prevError, stateError: "" }));
    }
    if (isVisiblePostCode && isPostCodeError.length > 0) {
      setIsLoading(false);
      setError((prevError) => ({
        ...prevError,
        postalCodeError: isPostCodeError,
      }));
    } else {
      setError((prevError) => ({ ...prevError, postalCodeError: "" }));
    }
    if (isVisibleZip && isZipError.length > 0) {
      setIsLoading(false);
      setError((prevError) => ({
        ...prevError,
        zipError: isZipError,
      }));
    } else {
      setError((prevError) => ({ ...prevError, zipError: "" }));
    }
    const isCheckPostCodeError = isVisiblePostCode && !isPostCodeError;
    const isCheckZipCodeError = isVisibleZip && !isZipError;
    const isCheckCityError = isVisibleCityState && !isCityError;
    const isCheckStateError = isVisibleCityState && !isStateError;

    const isFormValid =
      !isCardholderNameError &&
      !isExpMonthError &&
      !isExpYearError &&
      (!isVisibleCityState || isCheckStateError) &&
      (!isVisibleCityState || isCheckCityError) &&
      (!isVisiblePostCode || isCheckPostCodeError) && // Only validate if the field is visible
      (!isVisibleZip || isCheckZipCodeError) && // Only validate if the field is visible
      !buttonDisable;

    if (isFormValid) {
      window.inititatePayment = (tokenizedData) => {
        let customFieldsData = {
          ipcountry: countryCD,
          protalsrc: getPortalCD(),
          userguid: userGUID,
        };
        let data = createPaymentData({
          customFieldsData,
          customerSource: "",
          paypalToken: "",
          applePayToken: "",
          paymentToken: "",
          tokenizedData: {
            cardType: tokenizedData?.cardType,
            token: tokenizedData?.token,
          },
          expMonth: EXP_MONTH,
          expYear: EXP_YEAR,
        });
        data.firstName = FIRST_NAME;
        data.lastName = LAST_NAME || "";
        // let data = {
        //   assessmentId: assessmentId,
        //   firstName: FIRST_NAME,
        //   lastName: LAST_NAME || "",
        //   email: email,
        //   skuGuid: queryParams.get("sku"),
        //   userGuid: userGUID,
        //   portalSource: getPortalCD(),
        //   customFields: customFieldsData,
        //   customerSource: "",
        //   paypalToken: "",
        //   applePayToken: "",
        //   ipAddress: ipAddress,
        //   currency: currencyCD,
        //   assessmentAttemptId: currentassessmentAttemptId || "",
        //   visitId: readCookie("visitGuid"),
        //   visitorId: readCookie("visitorGuid"),
        //   maxSubUserCount: selectedPlan?.maxSubUserCount,
        //   paymentToken: "",
        //   userAddress: !!userAddress ? userAddress : null,

        //   ccDetails: {
        //     cardType: tokenizedData.cardType,
        //     token: tokenizedData.token,
        //     ccExpiryMonth: EXP_MONTH,
        //     ccExpiryYear: EXP_YEAR,
        //     cvv: "0",
        //   },
        // };
        let userMetaData = {
          visitId: readCookie("visitGuid"),
          visitorId: readCookie("visitorGuid"),
          email: email,
          device: device,
          browser: browser,
          paymentRequest: JSON.stringify(data),
          isPaymentButtonClicked: true,
        };

        userMetaConnect(userMetaData)
          .then((res) => {})
          .catch((err) => {
            console.log({ err });
          });
        setIsLoading(true);
        doCheckOutConnect(data)
          .then((response) => {
            if (!!response) {
              // response = 0;
              if (response === parseInt(0)) {
                window.flag = true;
                toast.error(
                  t("checkout.payment_declined"),
                  { autoClose: 5000 } // 5000 milliseconds = 5 seconds
                );
              } else {
                trackEvents("paymentSuccess", {
                  userGuid: userGUID,
                  email: email,
                  eventLabel: "Page View",
                  assessmentAttemptId: assessmentAttemptId,
                  countryCD: countryCD,
                  currencyCD: currencyCD,
                  portalCD: getPortalCD(),
                  gender: gender,
                  visitId: readCookie("visitGuid"),
                  visitorId: readCookie("visitorGuid"),
                });
                const encodedPg = encodeURIComponent(pg);
                const confirmationUrl = `${confirmationPath.next}?pt=${pt}&oid=${response}&pn=${pn}&pnes=${personalityNameEnglishCode}&pg=${encodedPg}`;
                navigate(confirmationUrl);
              }
            } else {
              window.flag = true;
              toast.error(
                t("checkout.payment_declined"),
                { autoClose: 5000 } // 5000 milliseconds = 5 seconds
              );
            }
          })
          .catch((error) => {
            // console.error("doCheckOutConnect failed", error);
            window.flag = true;
            trackEvents("paymentFailure", {
              userGuid: userGUID,
              email: email,
              eventLabel: "Page View",
              assessmentAttemptId: assessmentAttemptId,
              countryCD: countryCD,
              currencyCD: currencyCD,
              portalCD: getPortalCD(),
              gender: gender,
              visitId: readCookie("visitGuid"),
              visitorId: readCookie("visitorGuid"),
            });
          })
          .finally(() => {
            window.flag = true;
            setIsLoading(false); // Stop loader
          });
      };
    } else {
      setIsLoading(false);
    }
  };

  //PAYPAL IMPLEMENTATION
  const createPaypalAccessToken = () => {
    var axios = require("axios");
    var qs = require("qs");
    var data = qs.stringify({
      grant_type: "client_credentials",
    });
    var auth =
      "Basic " + btoa(getPaypalClientId() + ":" + getPaypalClientSecret());
    var config = {
      method: "post",
      url: getPaypalHostUrl() + "/v1/oauth2/token",
      headers: {
        Authorization: auth,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        if (!!response && !!response.data) {
          localStorage.setItem("ppat", response.data.access_token); //ppat=>PayPal Access Token
          createBillingAgreementToken(response.data.access_token);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const createBillingAgreementToken = (accessToken) => {
    let returnUrl = window.location.href + "&pplrtrn=true";
    let cancelUrl = window.location.href + "&cancel=true";
    let domainSubscription = "Insightfultraits Subscription";
    var data = JSON.stringify({
      description: domainSubscription,
      payer: {
        payment_method: "Paypal",
        payer_info: {
          email: email,
        },
      },
      plan: {
        type: "MERCHANT_INITIATED_BILLING",
        merchant_preferences: {
          return_url: returnUrl,
          cancel_url: cancelUrl,
          accepted_pymt_type: "INSTANT",
          skip_shipping_address: true,
          immutable_shipping_address: true,
        },
      },
    });
    let access_token = "Bearer " + accessToken;
    var config = {
      method: "post",
      url: getPaypalHostUrl() + "/v1/billing-agreements/agreement-tokens",
      headers: {
        "Content-Type": "application/json",
        Authorization: access_token,
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        localStorage.setItem("pptoken_id", response.data.token_id); //pp=>PayPal
        window.location = response.data.links[0].href;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const excecutePaypalProcess = (token) => {
    let subscriptionsource = "default";
    let uploadTime = new Date().toUTCString();
    let customFieldsData = {
      ipcountry: countryCD,
      protalsrc: getPortalCD(),
      userguid: userGUID,
    };
    let data = {
      assessmentId: assessmentId,
      firstName: email,
      lastName: "",
      email: email,
      skuGuid: queryParams.get("sku"),
      userGuid: userGUID,
      portalSource: getPortalCD(),
      customFields: customFieldsData,
      customerSource: subscriptionsource,
      paypalToken: token,
      applePayToken: "",
      ipAddress: ipAddress,
      currency: currencyCD,
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
      maxSubUserCount: selectedPlan?.maxSubUserCount,
      //userAddress: !!userAddress ? userAddress : null,
      userAddress: Object.values(userAddress).some((value) => value !== "")
        ? userAddress
        : null,
      ccDetails: null,
      paymentToken: "",
      assessmentAttemptId: currentassessmentAttemptId || "",
    };
    let userMetaData = {
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
      email: email,
      device: device,
      browser: browser,
      paymentRequest: JSON.stringify(data),
      isPaymentButtonClicked: true,
    };

    userMetaConnect(userMetaData)
      .then((res) => {})
      .catch((err) => {
        console.log({ err });
      });
    setIsLoading(true);
    doCheckOutConnect(data)
      .then((response) => {
        setIsLoading(true);
        if (!!response) {
          if (response === parseInt(0)) {
            window.flag = true;
            toast.error(
              t("checkout.payment_declined"),
              { autoClose: 5000 } // 5000 milliseconds = 5 seconds
            );
          } else {
            // console.log("doCheckOutConnect RESPONSE :::", response);
            trackEvents("paymentSuccess", {
              userGuid: userGUID,
              email: email,
              eventLabel: "Page View",
              assessmentAttemptId: assessmentAttemptId,
              countryCD: countryCD,
              currencyCD: currencyCD,
              portalCD: getPortalCD(),
              gender: gender,
              visitId: readCookie("visitGuid"),
              visitorId: readCookie("visitorGuid"),
            });
            const encodedPg = encodeURIComponent(pg);
            const confirmationUrl = `${confirmationPath.next}?pt=${pt}&oid=${response}&pn=${pn}&pnes=${personalityNameEnglishCode}&pg=${encodedPg}`;
            navigate(confirmationUrl);
          }
        } else {
          window.flag = true;
          toast.error(
            t("checkout.payment_declined"),
            { autoClose: 5000 } // 5000 milliseconds = 5 seconds
          );
        }
      })
      .catch((error) => {
        setIsLoading(false);
        window.flag = true;
        // console.error("doCheckOutConnect failed", error);
        trackEvents("paymentFailure", {
          userGuid: userGUID,
          email: email,
          eventLabel: "Page View",
          assessmentAttemptId: assessmentAttemptId,
          countryCD: countryCD,
          currencyCD: currencyCD,
          portalCD: getPortalCD(),
          gender: gender,
          visitId: readCookie("visitGuid"),
          visitorId: readCookie("visitorGuid"),
        });
      })
      .finally(() => {
        window.flag = true;
        // setIsLoading(false); // Stop loader
      });
  };
  const paypalHandler = () => {
    setIsLoading(true);
    let acccessToken = createPaypalAccessToken();
  };

  const userAddress = {
    state: formData.state,
    city: formData.city,
    zipCode: isVisibleZip ? formData.zip : formData.postCode,
    country:
      formData.state &&
      formData.city &&
      (isVisibleZip ? formData.zip : formData.postCode)
        ? country
        : "",
  };

  const FEATURES_LIST = [
    {
      id: 1,
      text: `${t("plan.plan_feature_one")}`,
      image: StarGold,
    },
    {
      id: 2,
      text: `${t("plan.invite")} ${selectedPlan?.maxSubUserCount} ${t(
        "plan.plan_feature_two"
      )}`,
      image: StarGold,
    },
    {
      id: 3,
      text: `${t("plan.plan_feature_three")}`,
      image: StarGold,
    },
    {
      id: 4,
      text: `${t("plan.plan_feature_five")}`,
      image: StarGold,
    },
  ];

  return (
    <>
      <div className="hidden md:block">
        <Header />
      </div>
      <div className="w-full flex justify-center items-center mt-[10px] mb-[5px] md:my-0">
        <div className="flex-shrink-0 mx-auto sm:mx-0 flex justify-center w-full sm:w-auto">
          <img
            src={LOGO}
            alt="logo"
            width={280}
            height={64}
            className="w-[185px] md:hidden h-auto flex flex-shrink-0"
          />
        </div>
      </div>
      {/* {------------------------Hidden fields -----------------------------} */}
      <input type="hidden" id="txOrigin" value={window.location.origin} />
      <input type="hidden" id="txID" value={getTokenExID()} />
      <input type="hidden" id="txTokenScheme" value={getTokenExScheme()} />
      <input type="hidden" id="txHMAC" value={createHmac()} />
      <input type="hidden" id="txTimestamp" value={getUTCTimeStamp()} />

      <div className="px-[10px] items-center text-center bg-white flex-grow mb-44">
        <Loader isLoading={isLoading} />
        {/* ------------------------ HEADING ------------------------ */}
        <h1 className="flex flex-col md:flex-row justify-center m-0 font-bold text-[20px] md:text-[28px] lg:text-[36px] text-center px-[0px] pb-[0px] lg:pb-[10px] pt-[0px] lg:pt-[10px]">
          <span className="text-[#444C5E]">
            {t("checkout.last_step_before")}&nbsp;
          </span>
          <span className="text-[#805AED]">
            {" "}
            {t("checkout.receiving_your_report")}
          </span>
        </h1>
        <div className="flex flex-col md:flex-col lg:flex-row justify-center items-center lg:items-stretch mt-[10px] space-y-0 md:space-y-0 lg:space-x-[10px] px-0 mb-0 lg:mb-0">
          {/* ---------------------- PAYMENT FORM ---------------------- */}
          <div
            className="bg-white shadow-md rounded-lg p-4 md:p-6 w-full max-w-xl
        border-2 border-[#FE6634] h-auto lg:m-0 mb-4"
          >
            <div className="flex justify-between items-center mb-[10px] md:mb-4">
              <h2 className="font-bold text-left text-[#444C5E] text-lg md:text-[26px]">
                {t("checkout.totalDue")}
              </h2>
              <span className="font-bold text-right text-[#444C5E] text-lg md:text-[26px]">
                {selectedPlan?.currencySymbol}
                {selectedPlan?.scheduleTypeCD === "YEAR"
                  ? formatToTwoDecimalPlaces(selectedPlan?.recurringPrice)
                  : formatToTwoDecimalPlaces(selectedPlan?.unitPrice)}
              </span>
            </div>
            <div className="flex mb-[10px] md:mb-4 mt-4 w-full justify-center items-center">
              <div
                className={`custom-control custom-radio btn-active sm:w-[120px]  h-[31px] sm:pl-4 pt-[2px] sm:pt-[0px]  border rounded-[3px] border-[#0a71cf] bg-[#f2f6ff] pointer mx-[2px] ${
                  showApplePay ? " w-[84px]" : "w-[120px]"
                }`}
              >
                <input
                  type="radio"
                  id="customRadioInline1"
                  name="customRadioInline1"
                  className="custom-control-input hidden"
                  defaultChecked
                />
                <label
                  className="custom-control-label inline-block relative before:absolute before:content-[''] before:w-[1rem] before:h-[1rem] before:block before:left-[-1.5rem] before:rounded-[50%] after:absolute after:content-[''] after:w-[1rem] after:h-[1rem] after:block after:left-[-1.5rem] after:top-[0px]"
                  htmlFor="customRadioInline1"
                >
                  <img
                    src={ALL_CARDS}
                    className="mx-auto w-[66px] h-[12px]"
                    alt="card"
                  />
                </label>
              </div>

              <div
                id="paypalRadio"
                className={` sm:custom-control sm:custom-radio paypal-icon block relative min-h-6 h-[31px] sm:pl-5 pt-[0px] rounded-[3px] border-[#f2f2f2] my-[0] mx-[2px] pointer text-center hover:cursor-pointer border-2 ${
                  showApplePay ? "w-[84px]" : "w-[120px] pl-5 ml-3"
                }`}
                onClick={paypalHandler}
                style={{ display: "flex", alignItems: "center" }}
              >
                <input
                  type="radio"
                  id="customRadioInline2"
                  name="customRadioInline1"
                  className="sm:custom-control-input hidden"
                  data-toggle="modal"
                  data-target="#paypal-loader-modal"
                />
                <label
                  className="sm:custom-control-label inline-block relative before:absolute sm:before:content-[''] sm:before:w-[1rem] sm:before:h-[1rem] sm:before:bg-[#dee2e6] sm:before:block sm:before:left-[-1rem] sm:before:rounded-[50%] sm:after:absolute sm:after:content-[''] sm:after:w-[1rem] sm:after:h-[1rem] sm:after:block sm:after:left-[-1rem] sm:after:top-[0px] sm:before:border-2 hover:cursor-pointer"
                  htmlFor="customRadioInline2"
                >
                  <img
                    src={PAYPAL_LOGO}
                    className="mx-auto w-[50px] mt-0 ml-1"
                    alt="card"
                  />
                </label>
              </div>
              {showApplePay && (
                <div
                  id="apple-pay-button"
                  className="sm:max-w-[120px] w-[84px] max-h-[31px] rounded-[3px] pointer mx-[2px]"
                ></div>
              )}
              <div
                id="gpay-button"
                className={`w-[120px] h-[31px] pt-[0px] rounded-[3px] pointer sm:mx-[2px] mx-[0px] ${
                  showApplePay ? "" : "sm:pl-[10px]"
                }`}
              ></div>
            </div>

            <form className="space-y-2" onSubmit={handleInputChange}>
              <AppTextField
                label={t("checkout.cardholder_name")}
                name="cardholderName"
                placeholder={t("checkout.cardholder_placeholder")}
                value={formData.cardholderName}
                onChange={handleInputChange}
                error={error.cardholderNameError}
                pattern="[A-Za-z\s]+"
                className="w-full mb-2 text-xs"
              />

              <div className="flex flex-row space-x-2 text-insightful-gray !important">
                <div className="w-4/5 lg:w-4/5">
                  <div className={`text-left relative max-w-full text-xs`}>
                    {t("checkout.card_number")}
                  </div>
                  <div
                    name="cardNumber"
                    id="tokenExIframeDiv"
                    className={`h-10 border w-full border-insightful-light-gray mt-1 rounded-md text-[12px]   font-normal pl-3 relative text-xs`}
                  ></div>
                  {error.cardNumberError && (
                    <p className="mt-1 text-[12px] text-red-600 text-left">
                      {error.cardNumberError}
                    </p>
                  )}
                </div>

                <div className="w-2/5 lg:w-1/5">
                  <div className={` text-left relative max-w-full text-xs`}>
                    {t("checkout.cvv")}
                  </div>
                  <div
                    name="cvv"
                    id="card-cvv-element"
                    className={`h-10 border border-insightful-light-gray mt-1 rounded-md text-[12px]  font-normal pl-3`}
                  ></div>
                  {error.cvvError && (
                    <p className="mt-1 text-[12px] text-red-600 text-left">
                      {error.cvvError}
                    </p>
                  )}

                  {/* <div id="tokenExIframeDiv" className="w-4/5 lg:w-4/5">
                  <AppTextField
                    label="CARD NUMBER"
                    name="cardNumber"
                    placeholder="1234 5678 9012 3456"
                    value={formData.cardNumber}
                    onChange={handleInputChange}
                    error={error.cardNumberError}
                    pattern="\d{16}"
                    className="w-full"
                  />
                </div>
                <div className="w-2/5 lg:w-1/5">
                  <div id="card-cvv-element" className="h-[40px] border border-gray-300 rounded-md text-[12px] text-insightful-gray font-bold" >
                   <AppTextField
                    label="CVV"
                    name="cvv"
                    placeholder="123"
                    value={formData.cvv}
                    onChange={handleInputChange}
                    error={error.cvvError}
                    pattern="\d{3,4}"
                    className="w-full"
                  />
                  </div>
                </div> */}
                </div>
              </div>

              <div className="flex flex-row space-x-2 mt-2">
                <div className="w-4/5 lg:w-4/5">
                  <DropDownSelector
                    label={t("checkout.exp_month")}
                    id="expMonth"
                    name="expMonth"
                    placeholder={t("checkout.exp_month_placeholder")}
                    value={formData.expMonth}
                    options={MONTH_OPTIONS}
                    onChange={handleInputChange}
                    error={error.expMonthError}
                    className="w-full border-insightful-light-gray focus:ring-insightful-gray focus:border-insightful-gray text-xs"
                  />
                </div>
                <div className="w-2/5 lg:w-1/5">
                  <DropDownSelector
                    label={t("checkout.exp_year")}
                    id="expYear"
                    name="expYear"
                    placeholder={t("checkout.exp_year_placeholder")}
                    value={formData.expYear}
                    options={YEAR_OPTIONS}
                    onChange={handleInputChange}
                    error={error.expYearError}
                    className="w-full border-insightful-light-gray focus:ring-insightful-gray focus:border-insightful-gray text-xs"
                  />
                </div>
              </div>

              <div className="flex flex-row space-x-2 mt-2">
                {isVisibleCityState && (
                  <div className="w-4/5 lg:w-4/5">
                    <AppTextField
                      label={cityName}
                      name="city"
                      placeholder={formatLabel(cityName)}
                      value={formData.city}
                      onChange={handleInputChange}
                      error={error.cityError}
                      className="w-full mb-2 text-xs"
                      onInput={formatCityState}
                    />
                  </div>
                )}

                {isVisibleCityState && (
                  <div className="w-4/5 lg:w-4/5">
                    <AppTextField
                      label={stateName}
                      name="state"
                      placeholder={formatLabel(stateName)}
                      value={formData.state}
                      onChange={handleInputChange}
                      error={error.stateError}
                      className="w-full mb-2 text-xs"
                      onInput={formatCityState}
                    />
                  </div>
                )}

                {isVisiblePostCode && (
                  <div className="w-4/5 lg:w-4/5">
                    <AppTextField
                      label={postCodeName}
                      name="postCode"
                      placeholder={formatLabel(postCodeName)}
                      value={formData.postCode}
                      onChange={handleInputChange}
                      error={error.postalCodeError}
                      className="w-full mb-2 text-xs"
                      onInput={formatPostalCode}
                    />
                  </div>
                )}
                {isVisibleZip && (
                  <div className="w-4/5 lg:w-4/5">
                    <AppTextField
                      label="ZIP CODE"
                      name="zip"
                      placeholder="zip"
                      value={formData.zip}
                      onChange={handleInputChange}
                      error={error.zipError}
                      maxLength={5} // Restrict input to 5 characters
                      className="w-full mb-2 text-xs"
                      onInput={allowOnlyNumbers}
                    />
                  </div>
                )}
              </div>
              <div className="mb-4 text-left">
                <div className="flex flex-col md:flex-row">
                  <div className="flex items-center gap-x-1 max-h-[30px]">
                    <img
                      src={ComodoSeal}
                      alt="Comodo Secure Seal"
                      className="w-[80px] h-auto max-h-max"
                    />
                    <div className="flex items-center gap-2">
                      <img src={Lock} alt="Lock Icon" width={10} height={10} />
                      <p className="text-insightful-gray text-[10px] md:text-[12px]">
                        {t("checkout.paymentSecurity")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-start items-start gap-3 mb-4 ">
                <label
                  htmlFor="acceptTerms"
                  className="text-insightful-gray text-[10px] md:text-[12px] text-left"
                >
                  {t("checkout.acceptanceMessage")}{" "}
                  <Link
                    to="https://insightfultraits.com/terms-conditions/"
                    className="text-insightful-purple"
                    target="_blank"
                  >
                    {t("footer.terms_and_conditions")}
                  </Link>
                  ,{" "}
                  <Link
                    to="https://insightfultraits.com/refunds-cancellations/"
                    className="text-insightful-purple"
                    target="_blank"
                  >
                    {t("footer.refund_policy")}
                  </Link>{" "}
                  {t("account.and")}{" "}
                  <Link
                    to="https://insightfultraits.com/privacy-policy/"
                    className="text-insightful-purple"
                    target="_blank"
                  >
                    {t("footer.privacy_policy")}
                  </Link>{" "}
                  {t("checkout.for_insightfultraits")}&nbsp;
                  <span dangerouslySetInnerHTML={{ __html: terms }} />{" "}
                  <strong>{termsDate}</strong>.{" "}
                  {t("checkout.customerSupportMessage")}{" "}
                  <Link
                    to="mailto:support@insightfultraits.com"
                    className="text-insightful-purple"
                  >
                    {t("plan.support_email")}
                  </Link>
                </label>
              </div>
            </form>
          </div>
          {/* ---------------------- REVIEW ORDER ---------------------- */}
          <div className="shadow-md rounded-lg p-4 md:p-6 w-full max-w-xl bg-[#FFE8E1]">
            <h2 className="font-bold text-left text-[#444C5E] text-lg md:text-[26px] mb-[0px] lg:mb-[20px]">
              {t("checkout.review_order")}
            </h2>

            <p className="font-semibold text-left text-[#444C5E] text-base md:text-[20px] mt-1 lg:mt-4">
              {selectedPlan?.title}
            </p>
            {FEATURES_LIST.map((feature) => (
              <p
                key={feature.id}
                className="flex items-center mt-4 text-[16px] md:text-[20px] font-normal text-left"
              >
                <img
                  src={feature.image}
                  alt="Bullet Point"
                  className="w-[45px] h-[45px] md:w-[45px] md:h-[45px] mr-[20px]"
                />
                {feature.text}
              </p>
            ))}

            <div className="flex justify-center mt-4">
              <hr className="border-t-2 border-black w-full" />
            </div>

            <div className="flex-col justify-between mt-4">
              <div className="w-full flex justify-between text-base md:text-[20px] my-[20px]">
                <span className="text-[#444C5E] font-bold mr-auto float-left">
                  {t("checkout.totalDue")}
                </span>
                <span className="text-[#444C5E] font-bold ml-auto float-right">
                  {selectedPlan?.currencySymbol}
                  {selectedPlan?.scheduleTypeCD === "YEAR"
                    ? formatToTwoDecimalPlaces(selectedPlan?.recurringPrice)
                    : formatToTwoDecimalPlaces(selectedPlan?.unitPrice)}
                </span>
              </div>
              {/* <div className="block h-full mt-auto fixed bottom-0 max-w-full w-full"> */}
              {/* {isLargeScreen && (
                <div className="block justify-center">

                </div>
              )} */}
              {isLargeScreen && (
                <div className="lg:block justify-center hidden">
                  <AppButton
                    onClick={onPaymentClickHandler}
                    className={`bg-[#FE6634] hover:bg-[#d5562b] text-white text-[16px] py-[10px] md:py-[20px] px-[20px] rounded-full font-bold ${
                      buttonDisable
                        ? "cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                    id="btnSubmit"
                    disabled={buttonDisable}
                  >
                    {t("checkout.get_my_report_cta")}
                  </AppButton>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer
        buttonTitle={t("checkout.get_my_report_cta")}
        onClick={onPaymentClickHandler}
        disabled={buttonDisable}
        buttonIcon={Arrow}
        buttonId="btnSubmit"
        className={`bg-[#FE6634] text-white fixed text-[16px] mt-[400px] py-4 md:py-8 font-regular ${
          buttonDisable ? "cursor-not-allowed" : "cursor-pointer"
        }`}
      />
    </>
  );
};

export default CheckoutB;
